import classNames from 'classnames'
import type { ReactNode } from 'react'
import { QUESTION_TILES, type QuestionTileId } from '../booking-questions-editor.domain'
import type { QuestionTypeTilesProps } from './question-type-tiles.interface'
import classes from './question-type-tiles.module.scss'

const TILE_ICON_PATHS: Record<QuestionTileId, ReactNode> = {
  short_text: <path d="M4 12h16M4 8v8" />,
  long_text: <path d="M4 7h16M4 12h16M4 17h10" />,
  dropdown: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M9 11l3 3 3-3" />
    </>
  ),
  multiple_choice: (
    <>
      <circle cx="7" cy="8" r="2.5" />
      <circle cx="7" cy="16" r="2.5" />
      <path d="M13 8h8M13 16h8" />
    </>
  ),
  yes_no: (
    <>
      <circle cx="8" cy="12" r="4" />
      <circle cx="8" cy="12" r="1.5" fill="currentColor" />
      <path d="M15 12h6" />
    </>
  ),
  checkboxes: (
    <>
      <rect x="3" y="4" width="6" height="6" rx="1.5" />
      <rect x="3" y="14" width="6" height="6" rx="1.5" />
      <path d="M13 7h8M13 17h8" />
    </>
  ),
}

export function QuestionTypeTiles({ selectedTileId, onSelect }: QuestionTypeTilesProps) {
  return (
    <div className={classes.root} role="group" aria-label="Answer type">
      {QUESTION_TILES.map((tile) => (
        <button
          key={tile.id}
          type="button"
          aria-pressed={tile.id === selectedTileId}
          className={classNames(classes.tile, { [classes.selected]: tile.id === selectedTileId })}
          onClick={() => onSelect(tile)}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={classes.icon}
            aria-hidden="true"
          >
            {TILE_ICON_PATHS[tile.id]}
          </svg>
          <span className={classes.label}>{tile.label}</span>
          <span className={classes.hint}>{tile.hint}</span>
        </button>
      ))}
    </div>
  )
}
